import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class WhatsAppTemplateAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/whatsapp-template', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (template, success, failure) => {
    fetch(Config.app.link + 'api/whatsapp-template', new Header('POST', template))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/whatsapp-template/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default WhatsAppTemplateAPI;